var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTuneYourValueIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F3EFF1",
    d: "M979.1,214.5l-163,163l-142.6-50.9l-50.9-142.6l163-163c-107-35.8-229.7-11.2-314.9,74 c-83.6,83.6-108.9,203.4-75.9,308.9c-4.4,3.5-8.7,7.2-12.8,11.3L47,750c-56,56-56,146.9,0,202.9c56,56,146.9,56,202.9,0l334.8-334.8 c4.1-4.1,7.8-8.4,11.3-12.8c105.5,32.9,225.3,7.7,308.9-75.9C990.2,444.2,1014.9,321.4,979.1,214.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTuneYourValueIcon);
export default __webpack_public_path__ + "static/media/tune-your-value-icon.05ea0e4dabefb35daa6b689a5aa05f46.svg";
export { ForwardRef as ReactComponent };